import constants from '../constants';

export default {
  filters: {
    fillColor(value) {
      return value !== undefined ? constants.DANGER_COLORS[value] : '#fff';
    },
    roseFillColor(value) {
      return value !== undefined ? constants.ROSE_DANGER_COLORS[value] : '#fff';
    },
  },
};
